const Years = Array.from({ length: new Date().getFullYear() - 1990 + 1 }, (_, i) => 1990 + i);

export default Years;